import type { PolicyDocument, PolicyId, PolicySeoMeta } from './types';
import { cookiePolicy } from './cookies';
import { enrichPolicyDocument } from './slug';
import {
  dpdpPolicy,
  gdprPolicy,
  privacyPolicy,
  refundPolicy,
  termsPolicy,
  trustPolicy,
} from './documents';

export const POLICY_DOCUMENTS: Record<PolicyId, PolicyDocument> = {
  privacy: privacyPolicy,
  terms: termsPolicy,
  gdpr: gdprPolicy,
  dpdp: dpdpPolicy,
  refund: refundPolicy,
  trust: trustPolicy,
  cookie: cookiePolicy,
};

export const POLICY_SEO: Record<PolicyId, PolicySeoMeta> = {
  privacy: {
    title: 'Privacy Policy — GoGrabJob',
    description:
      'How GoGrabJob collects, uses, stores, and deletes your resume and account data. Operated by Zykes Technologies LLP.',
    canonical: 'https://www.gograbjob.com/privacy-policy',
    breadcrumb: 'Privacy Policy',
  },
  terms: {
    title: 'Terms of Service — GoGrabJob',
    description:
      'The agreement between you and Zykes Technologies LLP for using GoGrabJob\'s AI job search platform.',
    canonical: 'https://www.gograbjob.com/terms-of-service',
    breadcrumb: 'Terms of Service',
  },
  gdpr: {
    title: 'GDPR Compliance — GoGrabJob',
    description:
      'Your data protection rights under GDPR when using GoGrabJob from the EEA, UK, or Switzerland.',
    canonical: 'https://www.gograbjob.com/gdpr-compliance',
    breadcrumb: 'GDPR Compliance',
  },
  dpdp: {
    title: 'DPDP Compliance — GoGrabJob',
    description:
      'How GoGrabJob complies with India\'s Digital Personal Data Protection Act, 2023 (DPDP Act).',
    canonical: 'https://www.gograbjob.com/dpdp-compliance',
    breadcrumb: 'DPDP Compliance',
  },
  refund: {
    title: 'Refund & Cancellation Policy — GoGrabJob',
    description:
      'Cancellation, auto-renew, and refund rules for GoGrabJob subscriptions and credit plans.',
    canonical: 'https://www.gograbjob.com/refund-cancellation',
    breadcrumb: 'Refund & Cancellation',
  },
  trust: {
    title: 'Trust Center — GoGrabJob',
    description:
      'Security practices, subprocessors, and data handling at GoGrabJob.',
    canonical: 'https://www.gograbjob.com/trust-center',
    breadcrumb: 'Trust Center',
  },
  cookie: {
    title: 'Cookie Policy — GoGrabJob',
    description:
      'Which cookies GoGrabJob sets, why, and how to control them through our consent banner.',
    canonical: 'https://www.gograbjob.com/cookie-policy',
    breadcrumb: 'Cookie Policy',
  },
};

export function getPolicyDocument(id: PolicyId): PolicyDocument {
  return enrichPolicyDocument(POLICY_DOCUMENTS[id]);
}

export { enrichPolicyDocument, buildPolicyToc } from './slug';
export type { PolicyDocument, PolicyId, PolicySeoMeta };
